



// Filename: public/coordinateLookup.js


import {fetch} from 'wix-fetch';
const options = {
    method: 'GET',
    credentials: 'include',
    cache: 'no-store'
};
export function coordinateLookup(lat,lng) {
    return fetch(`https://maps.googleapis.com/maps/api/geocode/json?latlng=${lat},${lng}&key=AIzaSyCIQ4iAHlRPp_t6zcal0zzE86HSWaKwoXg`)
        .then((httpResponse) => {
            if (httpResponse.ok) {
                return httpResponse.json();
            } else {
                return Promise.reject("Fetch did not succeed");
            }
        })
        .catch(err => console.log(err));
}



export async function ipLookup() {
    let result = await fetch(`https://api.ipify.org/?format=json`)
    return result.json();
}


export async function countryLookup(ip){
    let url = `https://ipapi.co/${ip}/json/`;
    console.log(url, "here is url")
    let result = await fetch(url)
    // return result;
    return result.json();
}